import React from 'react'
import AddUser from './AddUser'

const UserManagement = () => {
  return (
   <div className=' flex justify-center items-center w-full h-full'>
    <AddUser/>
   </div>
  )
}

export default UserManagement